import React, { useContext, useState, useEffect } from 'react';
import { Paper, Box, Grid, Avatar, Chip, FormControlLabel, Typography, TextField ,  Autocomplete , CircularProgress, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import MyTable from '../../components/Schedule/MyTable';
import SearchIcon from "@mui/icons-material/Search";
import './checklist.css'
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Col, Row } from 'react-bootstrap';

const ChecklistData = () => {
	const [loading, setLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [checklistSchedule , setChecklistSchedule] = useState([]);
	const [empList , setEmpList] = useState([]);
	const [selectedData , setSelectedData] = useState([]);
	const [selectedEmp , setSelectedEmp] = useState('');
	const [activeTab , setActiveTab] = useState('current-day');
	const [leftChecklistData , setLeftChecklistData] = useState([]);
	const [group , setGroup] = useState('');
	const [searchEmp , setSearchEmp] = useState('');
	const [showLastCheckedModal , setShowLastCheckedModal] = useState(false);
	const [lastCheckedList , setLastCheckedList] = useState([]);

	const columns = [
		{ field: 'title', headerName: 'Title', valueGetter: (params) => params.row.checklist?.title || '', minWidth: 180 },
		{
			field: 'checklist_date',
			headerName: 'Checklist Date',
			width: 180,
			valueGetter: (params) => moment(params.row.checklist_date).format('MM/DD/YYYY HH:mm:ss'),
		},
		{
			field: 'employee_full_name',
			headerName: 'Assigned to',
			width: 220,
			renderCell: (params) => (
				<Box display="flex" alignItems="center" gap={1}>
					<Typography>{params.row.employee_full_name}</Typography>
					{/* {params.row.status === 'pending' && (
						<EditIcon sx={{ color: '#555555', fontSize: 18 , cursor:'pointer'}} 
							onClick = {() => {
								setShowModal(true)
								setSelectedData(params?.row)
								setSelectedEmp(params?.row?.assigned_to); 
							}}
						/>
					)} */}
					<EditIcon sx={{ color: '#555555', fontSize: 18 , cursor:'pointer'}} 
						onClick = {() => {
							setShowModal(true)
							setSelectedData(params?.row)
							setSelectedEmp(params?.row?.assigned_to); 
						}}
					/>
				</Box>
			),
		},
		{ field: 'employee_email', headerName: 'Email', width: 220 },
		{
			field: 'status', headerName: 'Status', flex: 1, minWidth: 130,
			renderCell: (params) => {
				return (
					params?.row?.status == 'pending' ?
						<Chip style={{ width: '100px' , backgroundColor:'orange' , color:'#000000' }}
							label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)} />
						:
						<Chip
							sx={{
								backgroundColor: '#EDE1E1',
								color: '#000000',
								cursor: 'pointer',
								width: '100px'
							}}
							label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)}
						/>
				);
			}
		},
		{
			field: 'created_at',
			headerName: 'Created At',
			width: 120,
			valueGetter: (params) => moment(params.row.created_at).format('MM/DD/YYYY'),
		},
		{
			field: 'Last Checked',
			headerName: 'Last Checked',
			minWidth: 120,
			renderCell: (params) => {
				return (
					params?.row?.completed_employee_full_name !== null ? (
						<VisibilityIcon
							sx={{ color: '#0d6efd', cursor: 'pointer' }}
							onClick={() => {
								setLastCheckedList(params.row.past_completed_employees);
								setShowLastCheckedModal(true);
							}}
						/>
					)	: ''
				);
			}
		},
	];

	const columns2 = [
		{ field: 'title', headerName: 'Title', valueGetter: (params) => params.row.title || '', minWidth: 230 },
		{
			field: 'status', headerName: 'Status', flex: 1, maxWidth : 140,
			renderCell: (params) => {
				return (
					params?.row?.status == 'pending' ?
						<Chip style={{ width: '100px' , backgroundColor:'orange' , color:'#000000' }}
							label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)} />
						:
						<Chip
							sx={{
								backgroundColor: '#198754',
								color: '#ffffff',
								cursor: 'pointer',
								width: '100px'
							}}
							label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)}
						/>
				);
			}
		},
		{ field: 'total_schedules', headerName: 'Total Schedules', valueGetter: (params) => params.row.total_schedules || '', minWidth: 140 },
		{ field: 'time', headerName: 'Time', valueGetter: (params) => params.row.time	 || '', minWidth: 100 },
		{
			field: 'duration', headerName: 'Duration', flex: 1, maxWidth : 140,
			renderCell: (params) => {
				return (
					<Chip
							sx={{
								width: '100px'
							}}
							label={params.row.duration || ''}
					/>
				);
			}
		},
		{
			field: 'created_at',
			headerName: 'Created At',
			minWidth: 120,
			valueGetter: (params) => moment(params.row.created_at).format('MM/DD/YYYY'),
		},
		{
			field: 'Last Checked',
			headerName: 'Last Checked',
			minWidth: 260,
			renderCell: (params) => {
				return (
					params?.row?.last_completed_date ? (
						<Chip
							sx={{
								backgroundColor: '#0d6efd',
								color: '#ffffff',
								width: '100%'
							}}
							label={`${moment(params?.row?.last_completed_date).format('MM/DD/YYYY')} ,   ${params.row.completed_by_employee}`}
						/>
					)	: ''
				);
			}
		},
	];

	const getChecklist = (loader = true, empCode = '') => {
		if (loader) {
			setLoading(true)
		}
		ApiService.post('/checklist/cheif/checklist-schedule' , {
			emp_code : empCode
		})
			.then(({ data }) => {
				setChecklistSchedule(data || []);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const loadEmployees = () => {
		ApiService.get('/employeeToList').then(({ data }) => {
			setEmpList(data)
		}).catch(() => {
			toast.error("Error")
		})
	};

	useEffect(() => {
		getChecklist()
		loadEmployees()
	}, [activeTab == 'current-day'])

	const getLeftChecklist = (loader = true) => {
		if (loader) {
			setLoading(true)
		}
		ApiService.get('/checklist/cheif/left-checklists')
			.then(({ data }) => {
				setLeftChecklistData(data?.data || [])
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	useEffect(()=>{
		if(activeTab == 'other-day'){
			getLeftChecklist()
		}
	}, [activeTab == 'other-day'])

	const UpdateEmployee = (id) => {
		const body = {
			"checklist_id": selectedData?.checklist_id, 
			"checklist_schedule_id": selectedData?.id,
			"assigned_to": selectedEmp
		}
		ApiService.post('/checklist/cheif/update-assignment', body)
			.then(( data ) => {
				toast.success(data?.message)
				setShowModal(false)
				getChecklist()
				setLoading(false);
			})
			.catch(( error ) => {
				toast.error(error?.data?.message)
				setLoading(false);
			})
	}

	useEffect(() => {
		if (showModal && selectedData?.employee_code && empList.length > 0) {
			setSelectedEmp(selectedData.employee_code); 
		}
	}, [showModal, empList, selectedData]);

	const getGroup = () => {
		ApiService.get('/checklist/group-working-today')
			.then(({ data }) => {
				setGroup(data?.data || '')
			})
			.catch((e) => {
				console.error(e || 'error')
			})
	}

	useEffect(()=>{
		getGroup();
	} , [])


	return (
		<>
			{loading ? (
				<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
					<CircularProgress />
				</Paper>
			)
				:
				(
					<>
						<Paper className="p-4 font-fam" style={{ marginTop: "1rem", minHeight: '98%' }}>
							<Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px" }} >
								<Grid item xs={10} md={4}>
									<Typography variant="h5">Daily Checklist View</Typography>
								</Grid>
							</Grid>

							<Box className='mt-4'>
								 <Row>
										<Col style={{paddingRight:'0px' , paddingLeft:'0px' , flex:'0.1' , marginBottom:'10px'}}>
											<div style={{width:'160px'}}
												className={activeTab === 'current-day' ? 'tab-active mx-1' : 'tab-white mx-1'}
												onClick={() => setActiveTab('current-day')}
											>
												Current Day
											</div>
										</Col>
		
										<Col style={{paddingRight:'0px' , paddingLeft:'0px' , flex:'0.1' , marginBottom:'10px'}}>
											<div style={{width:'160px'}}
												className={activeTab === 'other-day' ? 'tab-active mx-1' : 'tab-white mx-1'}
												onClick={() => setActiveTab('other-day')}
											>
												Other Days
											</div>
										</Col>

										<Col style={{marginLeft:'20px', flex:'0.15' , marginBottom:'10px'}}>
											<div
												style={{
													backgroundColor: "rgba(191, 29, 45, 0.05)",
													borderRadius: "8px",
													display: "flex",
													alignItems: "center",
													justifyContent:'center',
													gap: "6px",
													padding: "6px 12px",
												}}
											>
												<p style={{ margin: 0 }}>Group -</p>
													<Chip
														label={group}
														size="small"
														style={{
															backgroundColor: "rgba(191, 29, 45, 0.8)",
															color:'#ffffff',
															fontSize: "12px",
															height: "22px",
															fontWeight:500
														}}/>
											</div>
										</Col>

										<Col style={{marginLeft:'auto', flex:'0 0 260px', marginBottom:'10px'}}>
											<Autocomplete
												size="small"
												options={empList}
												value={empList.find(emp => emp.Emp_Code === searchEmp) || null}
												getOptionLabel={(option) => ((option.EA_Rank || '') + ' ' + (option.fullName || '')).trim()}
												onChange={(_, value) => {
													const code = value?.Emp_Code || '';
													setSearchEmp(code);
													getChecklist(false, code);
												}}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Filter by Employee"
														variant="outlined"
														size="small"
														InputProps={{
															...params.InputProps,
															sx: {
																height: '40px',
																fontSize: '14px',
															},
														}}
														InputLabelProps={{
															sx: {
																fontSize: '14px',
															},
														}}
													/>
												)}
												isOptionEqualToValue={(option, value) =>
													option.Emp_Code === value?.Emp_Code
												}
											/>
										</Col>
									</Row>
							</Box>

							{activeTab == 'current-day' && 
								<div>
										{(checklistSchedule?.length === 0) ?
											<Box>
												<div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
													<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
													<div className='mt-2' style={{ color: '#555555' }}>
														No Checklist to be filled today!!
													</div>
												</div>
											</Box>
										:
											<>
												<div className='mt-3'>
													<MyTable
														rows={checklistSchedule}
														columns={columns}
														rowCount={checklistSchedule.length}
														checkboxSelection={false}
														hideFooter={true}
													/>
												</div>
											</>
									}
								</div>
							}

							{activeTab == 'other-day' &&
								<div>
									{(leftChecklistData?.length === 0) ?
											<Box>
												<div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
													<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
													<div className='mt-2' style={{ color: '#555555' }}>
														No Checklist !!
													</div>
												</div>
											</Box>
										:
											<>
												<div className='mt-3'>
													<MyTable
														rows={leftChecklistData}
														columns={columns2}
														rowCount={leftChecklistData.length}
														checkboxSelection={false}
														// hideFooter={true}
													/>
												</div>
											</>
									}
								</div>
							}

						</Paper >
					</>
				)}

			<div className='font-fam'>
				<Modal show={showModal} size="md"
					onHide={() => {
						setShowModal(false)
						setSelectedData([])
						setSelectedEmp('')
					}}>

					<Modal.Header closeButton>
						<Modal.Title>Change Employee</Modal.Title>
					</Modal.Header>

					<Modal.Body style={{ padding: 22 }}>
						<Autocomplete
							className="mt-0 w-100"
							options={empList}
							value={empList.find(emp => emp.Emp_Code === selectedEmp) || null}
							getOptionLabel={(option) => option.EA_Rank + ' ' + option.fullName}
							onChange={(_, value) => {
								setSelectedEmp(value?.Emp_Code || null); 
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Employee"
									variant="outlined"
									size="small"
									InputProps={{
										...params.InputProps,
										sx: {
											height: '48px',
											fontSize: '14px',
										},
									}}
									InputLabelProps={{
										sx: {
											marginTop: '3px',
											fontSize: '14px',
										},
									}}
								/>
							)}
							isOptionEqualToValue={(option, value) =>
								option.Emp_Code === value?.Emp_Code
							}
							disableClearable
						/>

						<Row>
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
										setShowModal(false)
										setSelectedData([])
										setSelectedEmp('')
									}}>
									Cancel
								</ButtonTheme>
							</Col>
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={UpdateEmployee}>
									Save
								</ButtonTheme>
							</Col>
						</Row>

					</Modal.Body>
				</Modal>

				<Modal show={showLastCheckedModal} size="md"
					onHide={() => {
						setShowLastCheckedModal(false)
						setLastCheckedList([])
					}}>
					<Modal.Header closeButton>
						<Modal.Title>Last Checked</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ padding: 22 }}>
						{lastCheckedList?.length > 0 ? (
							<ul style={{ paddingLeft: '20px', margin: 0 }}>
								{lastCheckedList.map((item, idx) => (
									<li key={idx} style={{ marginBottom: '6px' }}>
										{`${item.Emp_Name} (${moment(item?.checklist_date).format('MM/DD/YYYY')})`}
									</li>
								))}
							</ul>
						) : (
							<Typography>No records</Typography>
						)}
					</Modal.Body>
				</Modal>
			</div>
		</>
	)
}
export default ChecklistData;
